import React from 'react';
import { IAppPropsWithRoute } from '../../../common/types';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showNavbar } from '../../../store/modules/appStateSlice';
import Navbar from '../../shared/Navbar';
import { RootState } from '../../../store/rootReducer';
import HospitalPopup from "../../popup/HospitalPopup"
import ISelectItem from '../../popup/types/ISelectItem';
import { filterLocationForPopup, getLocationsDataForPopup } from '../../popup/hospitalPopupHelpers';
import SubHeader from './SubHeader';
import { getRoles } from './calloutResponseHelpers';
import { Button, makeStyles, MuiThemeProvider } from '@material-ui/core';
import themeDark from '../../shared/themeDark';
import AgedCareCalloutsForDriverWidget from './AgedCareCalloutsForDriverWidget';
import ChooseCalloutReason from './reasonsForCallout/ChooseCalloutReason';

interface AgedCareCalloutsForDriverPageProps extends IAppPropsWithRoute {

};

const initialLocation: string[] = [];


const useStyles = makeStyles(() => ({
    topLeftLabel: {
        fontSize: '1.125rem',
        fontFamily: 'lato',
        fontWeight: 'normal',
        lineHeight: 1.75,
        display: 'inline-flex',
        alignItems: 'center',
        height: '100%',
        paddingLeft: 24
    },
}));

const AgedCareCalloutsForDriverPage: React.FC<AgedCareCalloutsForDriverPageProps> = () => {
    const dispatch = useDispatch();
    const { authStore } = useSelector((state: RootState) => state);
    const popState = React.useState(false);
    const locationState = React.useState<ISelectItem[]>([]);
    const [selectedHospital, setSelectedHospital] = React.useState<any>("All Hospitals");
    const [selectedLocations, setSelectedLocations] = React.useState<string[]>(initialLocation);
    const [calloutReasonPage, setcalloutReasonPage] = React.useState(0);
    const requestCalloutIdForFinishStateArray = React.useState('');
    const showRules = getRoles(authStore);
    const classes = useStyles();

    React.useEffect(() => {
        dispatch(showNavbar(false));
        getLocationsData();
    }, [])

    const filterLocation = () => {
        filterLocationForPopup(locationState, setSelectedHospital, setSelectedLocations, null);
    }
    const getLocationsData = async (): Promise<void> => {
        await getLocationsDataForPopup(locationState,
            setSelectedHospital,
            setSelectedLocations,
            selectedLocations,
            null,
            authStore.clusterId);
    }

    const finishCallout = (requestCalloutId: string) => {
        const [_, setRequestCalloutIdForFinish] = requestCalloutIdForFinishStateArray;
        setRequestCalloutIdForFinish(requestCalloutId);
        setcalloutReasonPage(1);
    }

    if (calloutReasonPage > 0)
        return <ChooseCalloutReason
            requestCalloutIdForFinishStateArray={requestCalloutIdForFinishStateArray}
            setPage={setcalloutReasonPage} />;
    else
        return (
            <>
                <MuiThemeProvider theme={themeDark}>
                    <Navbar />
                    <SubHeader showRules={showRules} title={selectedHospital} leftButtonClick={() => popState[1](true)} />
                    <HospitalPopup popState={popState} filterLocation={filterLocation} locationState={locationState} />
                    <AgedCareCalloutsForDriverWidget
                        selectedLocations={selectedLocations.length === 0 ? initialLocation : selectedLocations}
                        authStore={authStore}
                        finishCallout={finishCallout}
                    />
                </MuiThemeProvider>
            </>
        );
}

export default withRouter(AgedCareCalloutsForDriverPage);